import React from 'react';

const DebugContainer: React.FC = () => {
  // Check if debug=true is in the URL query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const isDebug = urlParams.get('debug') === 'true';

  if (!isDebug) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="glass-card p-3 rounded-lg shadow-lg">
        <div className="text-xs text-neutral-600 dark:text-neutral-400">
          v{process.env.REACT_APP_VERSION || 'dev'}
        </div>
      </div>
    </div>
  );
};

export default DebugContainer;
